import MazeRenderer from "./maze-renderer";
import AnimationRenderer from "./types/animation-renderer";
import MapRenderer from "./types/map-renderer";
import MenuRenderer from "./types/menu-renderer";
import SlideRenderer from "./types/slide-renderer";
import LoadRenderer from "./types/load-renderer";
import BattleRenderer from "./battle-renderer";
export default class SceneRenderer {
    constructor() {
        this.renderers = {
            animation: new AnimationRenderer(),
            menu: new MenuRenderer(),
            slide: new SlideRenderer(),
            map: new MapRenderer(),
            maze: new MazeRenderer(),
            load: new LoadRenderer(),
            battle: new BattleRenderer(),
        };
        this.rendering = new Set();
        this.listeners = new Set();
        this.canvas = document.getElementById('canvas');
        this.audio = document.getElementById("audio");
    }
    render(app, appIndex) {
        var _a, _b;
        if (appIndex !== undefined && app.appIndex !== appIndex) {
            return;
        }
        this.clearRendering();
        const scene = (_a = app.scenes) === null || _a === void 0 ? void 0 : _a[(_b = app.sceneIndex) !== null && _b !== void 0 ? _b : 0];
        this.renderScene(app, scene);
    }
    renderScene(app, scene) {
        switch (scene === null || scene === void 0 ? void 0 : scene.type) {
            case "animationScene": {
                const renderer = this.renderers.animation;
                this.hookRendering(renderer, scene);
                renderer.addCompleteListener({
                    onComplete: (returnData) => this.nextScene(app, returnData),
                    onGoto: (name, returnData, position, direction) => {
                        this.gotoScene(app, name, returnData, position, direction, renderer.getConnectionTag(scene));
                    },
                });
                break;
            }
            case "menuScene": {
                const renderer = this.renderers.menu;
                this.hookRendering(renderer, scene);
                renderer.addCompleteListener({
                    onComplete: (returnData) => this.nextScene(app, returnData),
                    onGoto: (name, returnData, position, direction, tag) => {
                        this.gotoScene(app, name, returnData, position, direction, tag);
                    },
                });
                break;
            }
            case "slideScene": {
                const renderer = this.renderers.slide;
                this.hookRendering(renderer, scene);
                renderer.addCompleteListener({
                    onComplete: (returnData) => this.nextScene(app, returnData),
                    onGoto: (name, returnData, position, direction, tag) => {
                        this.gotoScene(app, name, returnData, position, direction, tag);
                    },
                });
                break;
            }
            case "mapScene": {
                const renderer = this.renderers.map;
                this.hookRendering(renderer, scene);
                renderer.addCompleteListener({
                    onComplete: (returnData) => this.nextScene(app, returnData),
                    onGoto: (name, returnData, position, direction, tag) => {
                        this.gotoScene(app, name, returnData, position, direction, tag);
                    },
                });
                break;
            }
            case "mazeScene": {
                const renderer = this.renderers.maze;
                this.hookRendering(renderer, scene);
                renderer.addCompleteListener({
                    onComplete: (returnData) => this.nextScene(app, returnData),
                    onGoto: (name, returnData, position, direction, tag) => {
                        this.gotoScene(app, name, returnData, position, direction, tag);
                    },
                });
                break;
            }
            case "loadScene": {
                const renderer = this.renderers.load;
                this.hookRendering(renderer, scene);
                renderer.addCompleteListener({
                    onComplete: (returnData) => this.nextScene(app, returnData),
                    onGoto: (name, returnData, position, direction, tag) => {
                        this.gotoScene(app, name, returnData, position, direction, tag);
                    },
                });
                break;
            }
            case "battleScene": {
                const renderer = this.renderers.battle;
                this.hookRendering(renderer, scene);
                renderer.addCompleteListener({
                    onComplete: (returnData) => this.nextScene(app, returnData),
                    onGoto: (name, returnData, position, direction, tag) => {
                        this.gotoScene(app, name, returnData, position, direction, tag);
                    },
                });
                break;
            }
        }
    }
    gotoScene(app, name, returnData, position, direction, tag) {
        var _a, _b, _c, _d;
        //    console.log("TAG", tag, md5(tag ?? ''));
        const nextIndex = (_c = (_b = (_a = app.scenes) === null || _a === void 0 ? void 0 : _a.findIndex(scene => scene.title === name)) !== null && _b !== void 0 ? _b : app.sceneIndex) !== null && _c !== void 0 ? _c : 0;
        app.sceneIndex = nextIndex >= 0 ? nextIndex : (_d = app.sceneIndex) !== null && _d !== void 0 ? _d : 0;
        if (app.scenes) {
            app.scenes[app.sceneIndex].returnData = returnData;
            app.scenes[app.sceneIndex].returnPosition = position;
            app.scenes[app.sceneIndex].returnDirection = direction;
        }
        this.listeners.forEach(listener => listener.onChange(app, false));
    }
    nextScene(app, returnData) {
        var _a, _b;
        app.sceneIndex = ((_a = app.sceneIndex) !== null && _a !== void 0 ? _a : 0) + 1;
        if ((_b = app.scenes) === null || _b === void 0 ? void 0 : _b[app.sceneIndex]) {
            app.scenes[app.sceneIndex].returnData = returnData;
        }
        this.listeners.forEach(listener => listener.onChange(app, false));
    }
    clearRendering() {
        this.rendering.forEach(renderer => { var _a; return (_a = renderer.stopRendering) === null || _a === void 0 ? void 0 : _a.call(renderer); });
        this.rendering.clear();
    }
    hookRendering(renderer, scene) {
        renderer.render(scene);
        this.rendering.add(renderer);
    }
    onChange(app, changeApp) {
        var _a;
        if (changeApp) {
            (_a = this.audio) === null || _a === void 0 ? void 0 : _a.pause();
        }
        this.render(app);
    }
}
